<template>
  <div class="recharge">
    <div class="form-horizontal">
      <recharge-form :user="fee.user" :fee="fee" mode="view"></recharge-form>
      <div class="form-group">
        <div class="col-sm-10 col-sm-offset-2">
          <button class="btn btn-primary" @click="print=true">打印</button>
        </div>
      </div>
    </div>
    <modal v-model="print" title="充值记录打印" size="sm">
      <fee-print :fee="fee" ref="print"></fee-print>
      <div slot="footer">
        <btn @click="print=false">取消</btn>
        <btn type="primary" @click="doPrint">确认打印</btn>
      </div>
    </modal>
  </div>
</template>

<script>
import FeePrint from '@/components/prints/FeePrint'
import RechargeForm from '@/components/forms/Recharge'
import * as TYPES from '../store/types'

export default {
  components: {
    RechargeForm,
    FeePrint
  },
  data() {
    return {
      mode: 'edit',
      print: false
    }
  },
  computed: {
    user() {
      return this.$store.state.users.view
    },
    fee() {
      return this.$store.state.users.recharge.feeView
    }
  },
  methods: {
    doPrint() {
      this.$center.invoke('PrintAccountRecord', this.fee)
      .then(() => {
        this.print = false
        this.$notify({
          type: 'success',
          content: '操作成功！'
        })
      })
      .catch(() => {
        this.$notify({
          type: 'danger',
          content: '操作失败！'
        })
      })
    }
  },
  mounted() {
    let idView = this.$route.params.id
    if (idView) {
      console.log(idView)
      this.mode = 'view'
      this.$store.dispatch(TYPES.DO_GET_ACCOUNT_RECORD, idView)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/AccountRecord.vue